import type { IconSvgObject } from './types';

const ExclamationMarkBigSlashIcon: IconSvgObject = [
  ["path", { d: "M10.5 6.5V5.5C10.5 4.67157 11.1716 4 12 4C12.8284 4 13.5 4.67157 13.5 5.5V9.5M10.5 10.5V12.5C10.5 13.3284 11.1716 14 12 14C12.5423 14 13.0175 13.7122 13.2809 13.2809", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 4L20 20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 20C12.8284 20 13.5 19.3284 13.5 18.5C13.5 17.6716 12.8284 17 12 17C11.1716 17 10.5 17.6716 10.5 18.5C10.5 19.3284 11.1716 20 12 20Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ExclamationMarkBigSlashIcon;
